import { combineReducers } from 'redux'
import onePropertyReducer, { onePropertyActions } from '@app-store/slices/properties/oneProperty'
import listPropertyReducer, { listPropertyActions } from '@app-store/slices/properties/list'
import listSearchPropertyReducer, { listSearchPropertyActions } from '@app-store/slices/properties/listSearch'
import deletePropertyReducer, { deletePropertyActions } from '@app-store/slices/properties/delete'
import createPropertyReducer, { createPropertyActions } from '@app-store/slices/properties/create'
import editPropertyReducer, { editPropertyActions } from '@app-store/slices/properties/edit'
import getPropertyUploadURLReducer, {
    getPropertyUploadURLActions
} from '@app-store/slices/properties/getPropertyUploadURL'
import urlPropertyReducer, { urlPropertyActions } from '@app-store/slices/properties/urls'
import oneUrlReducer, { oneUrlActions } from '@app-store/slices/properties/oneUrl'

export const propertiesReducer = combineReducers({
    list: listPropertyReducer,
    oneProperty: onePropertyReducer,
    create: createPropertyReducer,
    delete: deletePropertyReducer,
    edit: editPropertyReducer,
    getPropertyUploadURL: getPropertyUploadURLReducer,
    urls: urlPropertyReducer,
    oneUrl: oneUrlReducer,
    listSearch: listSearchPropertyReducer
})

export const propertiesActions = {
    list: listPropertyActions,
    oneProperty: onePropertyActions,
    create: createPropertyActions,
    delete: deletePropertyActions,
    edit: editPropertyActions,
    getPropertyUploadURL: getPropertyUploadURLActions,
    urls: urlPropertyActions,
    oneUrl: oneUrlActions,
    listSearch: listSearchPropertyActions
}
